import MetaTags from "react-meta-tags";
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
    CardTitle,
    Label,
    Input,
    Button,
    FormFeedback,
} from "reactstrap"
import { Link, Redirect } from "react-router-dom";
import Select from "react-select"
import { useState, useEffect } from 'react'
import axios from "axios";
import config from "../../config";
import { useToasts } from "react-toast-notifications";
import WV from '../../workVariables'
import InputSpinner from "react-bootstrap-input-spinner";
import { useHistory } from "react-router-dom";


const TihTilAdd = () => {
    const { addToast } = useToasts()
    const [redirect, setRedirect] = useState(false)

    const [form, setForm] = useState({
        name: '',
        tih_til: '',
        interval: '',
        part_candle: '',
        comment: ''
    })
    const [error, setError] = useState({
        name: false,
    });
    const [formErrors, setFormErrors] = useState({});
    const [isSubmit, setIsSubmit] = useState(false);
    const storeItem = (e) => {
        // e.preventDefault();
        setFormErrors(validate(form));
        setIsSubmit(true);
    };
    const validate = (values) => {
        const errors = {};
        // if (!values.name) errors.name = "поле обязательное для заполнения";
        if (!values.name) errors.name = " ";
        if (values.tih_til == '') errors.tih_til = "поле обязательное для заполнения";
        if (values.interval == '') errors.interval = "поле обязательное для заполнения";
        if (values.part_candle == '') errors.part_candle = "поле обязательное для заполнения";
        return errors;
    };
    useEffect(() => {
        if (Object.keys(formErrors).length === 0 && isSubmit) {
            axios.post(`${config.apiUrl}/tih-til/store`, form)
            .then((response) => {
                console.log(response.data);
                history.goBack()
                setTimeout(() => {
                    addToast(response.data.msg, {
                        appearance: response.data.res.toLowerCase(),
                        autoDismiss: true,
                        autoDismissTimeout: 7500,
                        transitionDuration: 2000
                    })

                }, 1000);
                if (response.data.res === "Success") {
                    setRedirect(true)
                }

            })
            .catch(error => {
                console.error(error);
            })
        }
    }, [formErrors]);   
    //белый цвет шрифта при поиске в Select
      const customStyles = {
        input: () => ({
            color:`${WV.colorSelectInput}`
        }),
    }
    const history = useHistory();
    let errorItem;
    return (
        <div className="page-content">
            <MetaTags>
                <title>Добавление TIH / TIL | TradeBot</title>
            </MetaTags>
            {/* <form onSubmit={storeItem}> */}
            {/* <Form> */}
            <Container fluid>
                <Row>
                    <Col className="col-12">
                        <Card>
                            <CardBody>
                                <CardTitle className={'mb-3'}>
                                    <div className='d-flex justify-content-between align-items-center'>
                                        <h4 className='mb-0'>Новый TIH / TIL</h4>
                                        <div className='d-flex gap-2 align-items-center'>
                                            <Button color="primary" onClick={storeItem}>
                                                Сохранить
                                            </Button>
                                            <Link to='/tih-til' className='btn btn-danger'>
                                                <i className='mdi mdi-backspace' />
                                                &nbsp;
                                                Вернуться
                                            </Link>
                                        </div>
                                    </div>
                                </CardTitle>
                                <Row>
                                    <Col xs={12} md={6} xl={6}>
                                        <div className="mb-3">
                                            <Label htmlFor="name">Название</Label>
                                            <Input
                                                type="text"
                                                className="form-control"
                                                placeholder='...'
                                                id="name"
                                                value={form.name}
                                                name="name"
                                                invalid={
                                                    (form.name.length === 0 && error.name) ||
                                                    formErrors.name
                                                }
                                                onChange={(e) => {
                                                    setForm({ ...form, [e.target.name]: e.target.value });
                                                    setError({ ...error, name: true })
                                                    errorItem = formErrors;
                                                    delete errorItem.name
                                                    setFormErrors(errorItem);
                                                }}
                                            />
                                            <FormFeedback invalid> {formErrors.name}
                                                {/* {formErrors.name
                                                    ? formErrors.name
                                                    : "это поле обязательное"} */}
                                            </FormFeedback>
                                        </div>
                                    </Col>
                                    <Col xs={12} md={6} xl={6}>
                                        <div className="mb-3">
                                            <Label htmlFor="period">Период</Label>
                                            <InputSpinner
                                                value={form.interval}
                                                name="interval"
                                                type={"real"}
                                                precision={0}
                                                max={1000}
                                                min={0}
                                                step={1}
                                                onChange={(num) => {
                                                    setForm({ ...form, interval: num })
                                                    setError({ ...error, interval: true })
                                                    errorItem = formErrors;
                                                    delete errorItem.interval
                                                    setFormErrors(errorItem);
                                                }}
                                            />
                                            <p style={{ 'fontSize': '10px', 'color': '#e06466' }}> {formErrors.interval}</p>                                         
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} md={6} lg={6}>
                                        <div className="mb-3">
                                            <Label htmlFor="tihtil">Тип TIH / TIL</Label>
                                            <Select
                                                theme={(theme) => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: `${WV.colorHoverSelect}`,
                                                        primary: `${WV.colorSelected}`,
                                                    },
                                                })}
                                                styles={customStyles} 
                                                id='tih_til'
                                                placeholder="выбрать..."
                                                options={[
                                                    { label: 'TIH', value: 'TIH' },
                                                    { label: 'TIL', value: 'TIL' },
                                                ]}
                                                classNamePrefix="select2-selection"
                                                name="tih_til"
                                                onChange={e => {
                                                    setForm({ ...form, tih_til: e.value });
                                                    setError({ ...error, tih_til: true })
                                                    errorItem = formErrors;
                                                    delete errorItem.tih_til
                                                    setFormErrors(errorItem);
                                                }}
                                            />
                                            <p style={{ 'fontSize': '10px', 'color': '#e06466' }}> {formErrors.tih_til}</p>
                                        </div>
                                    </Col>
                                    <Col xs={12} md={6} lg={6}>
                                        <div className="mb-3">
                                            <Label htmlFor="partCandle">Применяется к ценам</Label>
                                            <Select
                                                theme={(theme) => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: `${WV.colorHoverSelect}`,
                                                        primary: `${WV.colorSelected}`,
                                                    },
                                                })}
                                                styles={customStyles} 
                                                id='part_candle'
                                                placeholder="выбрать..."
                                                name="part_candle"
                                                options={[
                                                    { label: 'Открытия', value: 'open' },
                                                    { label: 'Закрытия', value: 'close' },
                                                    { label: 'High', value: 'high' },
                                                    { label: 'Low', value: 'low' },
                                                ]}
                                                classNamePrefix="select2-selection"
                                                onChange={e => {
                                                    setForm({ ...form, part_candle: e.value });
                                                    setError({ ...error, part_candle: true })
                                                    errorItem = formErrors;
                                                    delete errorItem.part_candle
                                                    setFormErrors(errorItem);
                                                }}
                                            />
                                            <p style={{ 'fontSize': '10px', 'color': '#e06466' }}> {formErrors.part_candle}</p>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} lg={12}>
                                        <div className="mb-3">
                                            <Label htmlFor="comment">Комментарии</Label>
                                            <Input
                                                type="text"
                                                className="form-control"
                                                placeholder='...'
                                                id="comment"
                                                name="comment"
                                                onChange={(e) => setForm({ ...form, [e.target.name]: e.target.value })}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>                      
                    </Col>
                </Row>
            </Container>
            {/* </Form> */}
            {/* </form> */}

            {/* {redirect &&
                <Redirect
                    to={{
                        pathname: "/tih-til",
                    }}
                />
            } */}

        </div>
    )
}

export default TihTilAdd